import { HTMLAttributes } from 'react'

import { useLenis, useScrollbar } from '@/contexts/lenis'

// import { useLoaderStore } from '@/store/loader'
import { cn } from '@/lib/utils'

export type ScrollbarProps = HTMLAttributes<HTMLDivElement>

const Scrollbar = ({ className, ...props }: ScrollbarProps) => {
  const { lenis } = useLenis()
  const [track, thumb, needsScrollbar] = useScrollbar(lenis)
  // const heroCanPlay = useLoaderStore((state) => state.heroCanPlay)

  return (
    <div
      className={cn(
        'z-scrollbar group fixed bottom-0 right-0 top-0 w-[1.2rem] touch:hidden',
        {
          visible: needsScrollbar,
          invisible: !needsScrollbar
        },
        /* {
          'opacity-100': heroCanPlay
        }, */
        className
      )}
      {...props}
    >
      <div ref={track} className="relative h-full w-full">
        <div
          ref={thumb}
          className={cn(
            'absolute left-0 top-0 w-full',
            'before:absolute before:bottom-[.2rem] before:left-[.7rem] before:top-[.2rem] before:w-[.2rem] before:bg-white-dark'
          )}
        />
      </div>
    </div>
  )
}

export default Scrollbar
